export const attendeeFilterStyle = {
    filterButton: {
        background: "#fff",
        border: "1px solid #E7E7E7",
        padding: "0 15px",
        height: "42px",
        boxShadow: "0px 4px 8px rgb(0 0 0 / 5%)",
        borderRadius: "6px",
        width: "100%",
        justifyContent: "space-between",
    },
    filterMenu: {
        marginTop: "5px",
    },
    filterForm: {
        marginLeft: "5px",
        zIndex: 1,
        background: "#fff",
        boxShadow:
            "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
        borderRadius: "4px",
    },
    filterFormWrapper: {},
    filterFormControls: { padding: "12px 16px" },
    filterFormActions: { padding: "12px 16px", textAlign: "right" },
    filterValueInput: {
        width: "170px",
        padding: 0,
        margin: "10px 0",
    },
    filterCategoryInput: {
        "& input": {
            width: "170px",
            padding: 0,
            margin: "10px 0",
        },
    },
    categotyAutoComplete: {
        width: "180px",
        '& input': {
            padding: "0 5px !important",
            margin: '0px !important',
            height: '30px',
        }
    },
    filterAutoComplete:{
        '& input':{
         width: "180px",
        padding: "0 5px !important",
        margin: '0px !important',
        height:'30px',
       }
      },
      searchTextField:{
                
        '& .MuiInputBase-root':{
          padding:'0 10px',
          height:'30px',
          width: "180px",
        },
       '& input':{
        padding: "0 !important",
        margin: '0px !important',
       }
      },
} as const;